export default {
  interactionsAndEngagement: {
    title: 'Interações e índice de engajamento',
    descriptions: {
      default: 'Índice de engajamento = (curtidas + comentários x 1,5 + compartilhamentos x 2) / número de fãs) x 1000 no período selecionado.',
      instagram: 'Índice de engajamento = (curtidas + comentários x 1,5) / número de fãs) x 1000 no período selecionado.',
      youtube: 'Índice de engajamento = (curtidas + comentários x 1,5) / número de views) x 1000 no período selecionado.',
    },
    chartOptions: {
      yAxis: {
        rightVerticalTitle: 'Índice de engajamento',
        leftVerticalTitle: 'Interações',
      },
    },
  },
  feedbackCard: {
    messageChartsSentiments: 'Os sentimentos dos comentários das publicações da rede social Instagram não estão inclusos nos gráficos. A API pública não fornece os comentários para análise.',
  },
  sentimentsInTheCommentsOverTime: {
    title: 'Sentimento nos comentários ao longo do tempo',
    description: 'Classificação com base em comentários nas publicações do período selecionado',
  },
  publicationsOverTimeWithDistribution: {
    title: 'Publicações e suas interações',
    description: 'Entenda a distribuição das interações nas publicações ao longo do tempo no período selecionado.',
    chartOptions: {
      yAxis: {
        verticalTextRight: 'Interações',
        verticalTextLeft: 'Publicações',
      },
    },
  },
};
